import { useContext, useEffect, useRef } from "react";
import { UNSAFE_NavigationContext } from "react-router-dom";
export default function useUnsavedContent(dirty, rootRef) {
  const navigation = useContext(UNSAFE_NavigationContext);
  const dirtyRef = useRef(dirty);
  dirtyRef.current = dirty;
  useEffect(() => {
    let approved = false;
    let restoring = false;
    let currentIndex = window.history.state?.idx;
    const allow = () => !dirtyRef.current || approved || window.confirm("Є незбережені зміни. Залишити редактор?");
    const unload = event => {
      if (!dirtyRef.current) return;
      event.preventDefault();
      event.returnValue = "";
    };
    const click = event => {
      const target = event.target.closest?.("a, button, [class*='mainPageButtonO']");
      if (!target || rootRef.current?.contains(target)) return;
      if (!allow()) {
        event.preventDefault();
        event.stopPropagation();
      } else {
        approved = true;
        setTimeout(() => {
          approved = false;
        }, 0);
      }
    };
    const pop = event => {
      if (restoring) {
        restoring = false;
        return;
      }
      const nextIndex = event.state?.idx;
      if (dirtyRef.current && typeof currentIndex === "number" && typeof nextIndex === "number" && !allow()) {
        event.stopImmediatePropagation();
        restoring = true;
        window.history.go(currentIndex - nextIndex);
      } else currentIndex = nextIndex;
    };
    const navigator = navigation?.navigator;
    const originals = {};
    const wrappers = {};
    if (navigator) ["push", "replace"].forEach(method => {
      originals[method] = navigator[method];
      wrappers[method] = (...args) => {
        if (allow()) return originals[method].apply(navigator, args);
      };
      navigator[method] = wrappers[method];
    });
    window.addEventListener("beforeunload", unload);
    window.addEventListener("popstate", pop, true);
    document.addEventListener("click", click, true);
    return () => {
      window.removeEventListener("beforeunload", unload);
      window.removeEventListener("popstate", pop, true);
      document.removeEventListener("click", click, true);
      if (navigator) Object.keys(originals).forEach(method => {
        if (navigator[method] === wrappers[method]) navigator[method] = originals[method];
      });
    };
  }, [navigation, rootRef]);
}
